import { SORT_DIRECTIONS } from './tableSortDirections';

const compareValues = (left, right) => {
  if (typeof left === 'string' || typeof right === 'string') {
    return String(left).localeCompare(String(right), 'es', { numeric: true, sensitivity: 'base' });
  }
  return left < right ? -1 : left > right ? 1 : 0;
};

/**
 * Ordena en el navegador listas que ya llegan completas (sin paginación del servidor).
 * Los valores vacíos quedan siempre al final.
 * @param {Array<Object>} rows Renglones a ordenar; no se modifica.
 * @param {{key: string, direction: string}|null} sort Orden elegido.
 * @returns {Array<Object>} Copia ordenada, o la misma lista si no hay orden.
 */
export const sortRows = (rows, sort) => {
  if (!sort || !Array.isArray(rows)) return rows;
  const factor = sort.direction === SORT_DIRECTIONS.desc ? -1 : 1;
  return [...rows].sort((left, right) => {
    const leftValue = left?.[sort.key];
    const rightValue = right?.[sort.key];
    const leftEmpty = leftValue === null || leftValue === undefined || leftValue === '';
    const rightEmpty = rightValue === null || rightValue === undefined || rightValue === '';
    if (leftEmpty || rightEmpty) return Number(leftEmpty) - Number(rightEmpty);
    return compareValues(leftValue, rightValue) * factor;
  });
};
